import { For, Show } from "solid-js";
import { Product } from "~/server/types/search";
import { BrandCardTelescopeLargeRnr } from "~/components/webstore_telescope/brand_card_telescope";
import { BrandCardMobileRnr } from "~/components/webstore_telescope/brand_card_mobile_rnr";
import { useHomeV3Context } from "../context/home_v3_context";
import { isMobile } from "~/utils/platform";
import { useWebStoreContext } from "~/context/webstore_context";
import { clientIdConfig } from "~/data/partner_config";

export type BrandGridProps = {
  brands: Product[];
  onBrandClick: (brandKey: string) => void;
  forceDarkTheme?: boolean;
};

export function BrandGrid(props: BrandGridProps) {
  const { getClientId } = useWebStoreContext();
  const { getGridCols, hasLimitedBrands } = useHomeV3Context();

  return (
    <div
      class="mx-auto grid w-full max-w-[1024px]  gap-x-3 gap-y-6 px-3 sm:px-0 md:gap-x-[12px] md:gap-y-[16px]"
      classList={getGridCols()}
    >
      <For each={props.brands}>
        {(brand) => (
          <Show
            when={isMobile() && !hasLimitedBrands()}
            fallback={
              <BrandCardTelescopeLargeRnr
                forceDarkTheme={props.forceDarkTheme}
                imageUrl={brand.voucherProduct.sqLogoUrl}
                name={brand.voucherProduct.title}
                discountPercentage={brand.voucherProduct.discountPercentage}
                cardBackgroundColor={brand.voucherProduct.cardBackgroundColor}
                onClick={() => props.onBrandClick(brand.brandKey)}
                heroImageUrl={brand.voucherProduct.heroImageUrl}
                showHeroImage={
                  getClientId() !== clientIdConfig.buddydealsClientId
                }
              />
            }
          >
            <BrandCardMobileRnr
              forceDarkTheme={props.forceDarkTheme}
              imageUrl={brand.voucherProduct.iconImageUrl}
              name={brand.voucherProduct.title}
              discountPercentage={brand.voucherProduct.discountPercentage}
              onClick={() => props.onBrandClick(brand.brandKey)}
            />
          </Show>
        )}
      </For>
    </div>
  );
}
